import type { FaireProductEntity } from "../../entity_types/product";

export const p_57zffppe2w: FaireProductEntity = {
  token: "p_57zffppe2w",
  type: "product",
  name: "Spring Neutrals Leather Loafers Shoes Baby and Toddler",
  brandToken: "b_ynyj2tklh3",
  brandName: "Starry Knight Design",
  imageUrl:
    "https://cdn.faire.com/fastly/360ab14a5988fbbf689368b4d18a4cbb6522f048b05fee745a8c6b56d989467f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed8a39bc68f94b9ad96285916d71acd233623333deec3a47bd264b018aa77d6b.jpeg",
    "https://cdn.faire.com/fastly/dd6766d84383ae5821b59c755b9acb56b442a8d336ab898f8b49bda5f30e547d.jpeg",
    "https://cdn.faire.com/fastly/739c8d218f03766a2b503ff563b2e0a6c7a0aa981f15acc65183bbbaf6826a3e.jpeg",
    "https://cdn.faire.com/fastly/e9a4c9365e121b539771a1a38484a677ca9a10904da68728a68b61a49bb193f9.jpeg",
    "https://cdn.faire.com/fastly/7111fa77f13a1bde77912b5ead2dd1618f17f2f7b568a10b3bc42f4bd02356bc.jpeg",
    "https://cdn.faire.com/fastly/bc6041dfa913df2fe6b046c81bc5eb87318c78cddc7a2ff1cd33a12f594c6fb9.jpeg",
    "https://cdn.faire.com/fastly/9703c31bfa0383de2b9ee40e153b4150452bb0262834be549d22576b8fb0b9d3.jpeg",
    "https://cdn.faire.com/fastly/09d2cb4177f36156bc7f0e2277fd4e19d432cca6683e147a8b71c6e85ac1679b.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "Starry Knight Design shoes are handmade in Montana USA by a team of local women with high-quality 100% leather and suede. Since 2008, We have been designing and making soft soled leather shoes for your tiny babies up to kids. Our Shoes are great for ages newborn to 4years:\n\n-Soft and non restrictive for developing feet\n\n-Soft Elastic band around ankle \n\n-Help keep socks on newborns\n\n-great for babies crawling around\n\n-perfect for balance when they start standing and walking \n\n-suede bottoms help make non slip for floors\n\n-good for house/daycare shoes for toddlers! Or with our Add on soles even outdoor shoes Starry Knight Design Shoes\n\n-- 100% high quality leather and suede\n\n-- Handmade in Montana USA \n\n- Current Turnaround Time 1-2weeks\n\n-- Please measure child's foot before ordering to select the correct size. Add 3/8” to measurement to get correct sole length. Refer to size chart link for correct sizing info",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:17.680Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
